__turbopack_context__.v({
  "className": "hackfont_f6747974-module__3Ku1aa__className",
  "variable": "hackfont_f6747974-module__3Ku1aa__variable",
});
